import apiCall from "../../apis/axios_instance";
import { convertScripResponseWatchlistGrid, getAssetExchangeNameFromMktSegId, getInstrumentName, getMktSegIdFromApiExchangeName, getViewAllowed, getViewAllowedOptnChain, modifySymbol, sortDateInStringsInSequence } from "../../utils/global_functions";
import { BUSINESS_LAYER_RESPONSE, MULTILEG_DATA_OPTION_INDEX, OPTION_CHAIN, OPTION_CHAIN_GRID_INDEX, SCRIP_INSTRUMENTS, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { OPTION_CHAIN as location } from "../../utils/global_variables";
import config from '../../config.json';
const { TenantId } = config;

function _getNumericMonth(sMonth) {
  try {
    let sRetval = "";
    switch (sMonth) {
      case "JAN":
        sRetval = "00";
        break;
      case "FEB":
        sRetval = "01";
        break;
      case "MAR":
        sRetval = "02";
        break;
      case "APR":
        sRetval = "03";
        break;
      case "MAY":
        sRetval = "04";
        break;
      case "JUN":
        sRetval = "05";
        break;
      case "JUL":
        sRetval = "06";
        break;
      case "AUG":
        sRetval = "07";
        break;
      case "SEP":
        sRetval = "08";
        break;
      case "OCT":
        sRetval = "09";
        break;
      case "NOV":
        sRetval = "10";
        break;
      case "DEC":
        sRetval = "11";
        break;
      default:
        break;
    }
    return sRetval;

  } catch (error) {
    console.log("error", error);
  }
}




function _dateDiffernece(inputdate) {

  try {
    let numDay = parseInt(inputdate?.substr(0, 2));
    let strMonth = parseInt(_getNumericMonth(inputdate?.substr(2, 3))) + 1;
    strMonth = strMonth < 10 ? "0" + strMonth.toString() : strMonth;
    let numYear = parseInt(inputdate?.substr(-4));
    let strNewDate = strMonth + '/' + numDay + '/' + numYear + ' ' + '00' + ':' + '00' + ':' + '00';
    let strNextdate = new Date(strNewDate);
    let strCurrentDate = new Date();
    let numDiffTime = Math.abs(strNextdate - strCurrentDate);
    let NumDiffDays = Math.ceil(numDiffTime / (1000 * 60 * 60 * 24));
    return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: NumDiffDays };
  } catch (error) {
    console.log("error", error);
    return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
  }
}



async function _modifyOptionDataWrtAPI(expiryDate, symbol, objLoginSession) {
  const objResp = await apiCall.get(`/nontransactional/${TenantId}/v1/getScripFromInstrumentAndExchange/null/${expiryDate}/${symbol}/${objLoginSession?.nExchangesViewAllowed}`);

  let arrSelectedOptionContractData;

  if (objResp?.status) {
    if (objResp?.data?.result.hits !== undefined) {
      if (objResp?.data?.result?.hits?.hits.length > 0) {
        arrSelectedOptionContractData = objResp?.data?.result.hits.hits;
      }
    }
  }

  if (arrSelectedOptionContractData?.length) {
    return _modifyOptionData(arrSelectedOptionContractData, expiryDate);
  }

}


function _combineArrays(arr1, arr2) {
  // Find the minimum length of the two arrays
  const minLength = Math.min(arr1.length, arr2.length);

  // Use map to combine objects from both arrays up to the minimum length
  const combinedArray = Array.from({ length: minLength }, (_, index) => {
    const obj1 = arr1[index];
    const obj2 = arr2[index];
    // Merge properties of obj1 and obj2 using the spread operator
    const combinedObj = { ...obj1, ...obj2 };
    return combinedObj;
  });

  return combinedArray;
}




function _modifyOptionData(arrOptionData, strExpiryDate) {



  /*arrOptionData => It is response array which we get by firing getScripFromInstandExchange api */
  /*strExpiryDate => It contains expiry selected expiry date */

  try {

    const arrOptData = arrOptionData?.filter(x => x._source.nExpiryDate1 === strExpiryDate).map(y => y._source);


    let objOptionChainData = {};
    let arrOptCEData = [];
    let arrOptPEData = [];
    let arrStrikePrices = [];
    let objAssetToken = {};
    let arrCallPut = [];



    let strExchangeName = getAssetExchangeNameFromMktSegId(arrOptData[0]?.MktSegId);

    let numAssetId = getMktSegIdFromApiExchangeName(strExchangeName);

    objAssetToken = { exchangeId: numAssetId, token: arrOptData[0]?.nAssetToken, isSubscribe: true };

    let objPut = {
      LTP_PUT: 0.00,
      OI_PUT: 0.00,
      IV_PUT: 0.00,
      GAMMA_PUT: 0.00,
      DELTA_PUT: 0.00,
      BETA_PUT: 0.00,
      THETA_PUT: 0.00,
      PERCENT_CHANGE_PUT: 0,
      MKT_ID_PUT: 0,
      TOKEN_PUT: 0.00,
      CHANGE_IN_LTP_PUT: 0.00,
      LTP_PERCENT_PUT: 0.00,
      ASK_QTY_PUT: 0.00,
      BUY_PRICE_PUT: 0.00,
      SELL_PRICE_PUT: 0.00,
      STRIKE_PRICE: 0.00,
      OPT_TYPE_PUT: 0.00,
      STRIKE_PUT: 0.00,
      id: null,
      VOLUME_PUT: 0,
    };

    const objCall = {
      LTP_CALL: 0,
      OI_CALL: 0,
      IV_CALL: 0,
      GAMMA_CALL: 0,
      DELTA_CALL: 0,
      BETA_CALL: 0,
      THETA_CALL: 0,
      PERCENT_CHANGE_CALL: 0,
      MKT_ID_CALL: 0,
      TOKEN_CALL: 0,
      CHANGE_IN_LTP_CALL: 0,
      LTP_PERCENT_CALL: 0,
      ASK_QTY_CALL: 0,
      BUY_PRICE_CALL: 0,
      SELL_PRICE_CALL: 0,
      STRIKE_PRICE: 0,
      OPT_TYPE_CALL: 0,
      STRIKE_CALL: 0,
      id: null,
      VOLUME_CALL: 0,
      //CALL_EXPIRY_DATE: strExpiryDate,
    };

    //Ameersha N : 19-04-2023 - Breeze -BT-109096 -- Scrip Overview Option Chain --Start
    for (let i = 0; i < arrOptData?.length; i++) {
      objOptionChainData[`${arrOptData[i]?.MktSegId + '-' + arrOptData[i]?.nToken}`] = {
        nStrikePrice: arrOptData[i]?.nStrikePrice,
        nStrikePrice1: arrOptData[i]?.nStrikePrice1,
        nExpiryDate1: arrOptData[i]?.nExpiryDate1,
        sOptionType: arrOptData[i]?.sOptionType,
        nAssetToken: arrOptData[i]?.nAssetToken,
        MktSegId: arrOptData[i]?.MktSegId,
        data: convertScripResponseWatchlistGrid([arrOptData[i]])[0],
        decimalLocator: arrOptData[i]?.DecimalLocator
      };
      //Ameersha N : 19-04-2023 - Breeze -BT-109096 -- Scrip Overview Option Chain --End

      if (arrOptData[i].sOptionType === 'CE') {
        arrOptCEData.push({ ...objCall, ['MKT_ID_CALL']: arrOptData[i]?.MktSegId, ['TOKEN_CALL']: arrOptData[i]?.nToken, ['STRIKE_PRICE']: arrOptData[i]?.nStrikePrice1, callId: `${arrOptData[i]?.MktSegId}_${arrOptData[i]?.nToken}`, id: `${arrOptData[i]?.MktSegId}_${arrOptData[i]?.nToken}`, OPT_TYPE_CALL: 'CALL', STRIKE_CALL: arrOptData[i]?.nStrikePrice1, OPT_EXPIRY_CALL: arrOptData[i].nExpiryDate1 });
        arrStrikePrices.push({ strike: arrOptData[i]?.nStrikePrice1 });
      }

      if (arrOptData[i]?.sOptionType === 'PE') {
        arrOptPEData.push({ ...objPut, ['MKT_ID_PUT']: arrOptData[i]?.MktSegId, ['TOKEN_PUT']: arrOptData[i]?.nToken, ['STRIKE_PRICE']: arrOptData[i]?.nStrikePrice1, putId: `${arrOptData[i]?.MktSegId}_${arrOptData[i]?.nToken}`, id: `${arrOptData[i]?.MktSegId}_${arrOptData[i]?.nToken}`, OPT_TYPE_PUT: 'PUT', STRIKE_PUT: arrOptData[i]?.nStrikePrice1, OPT_EXPIRY_PUT: arrOptData[i].nExpiryDate1 });
      }
    }


    arrCallPut = _combineArrays(arrOptCEData, arrOptPEData);


    return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { arrStrikePrices, arrCallPut, objOptionChainData, objAssetToken } };

  } catch (error) {

    return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };

  }

}




function _getChangeInRs(LTP, ClosePrice, nFormat, isMktWatch, arrowType) {

  try {

    let arrChnageData = [];
    if (LTP !== '' && ClosePrice !== '') {
      ClosePrice = ClosePrice / 100;
      let numNetChgRs = parseFloat(LTP) - parseFloat(ClosePrice);
      let numNetChangeInRs = numNetChgRs.toFixed(nFormat);
      let PercNetChng = parseFloat(ClosePrice) !== 0 ? (parseFloat(numNetChangeInRs) / parseFloat(ClosePrice)) * 100 : 0;
      let PercNetChange = PercNetChng.toFixed(2);
      let LTPTrend = '';

      if (parseFloat(numNetChangeInRs) > 0) {
        arrChnageData.push('+' + Math.abs(parseFloat(numNetChangeInRs)).toFixed(nFormat));
        arrChnageData.push("+" + Math.abs(parseFloat(PercNetChange)).toFixed(2) + "%");
        ///arrChnageData.push("+" + Math.abs(parseFloat(PercNetChange)).toFixed(2));
        LTPTrend = "color-positive";
      }
      else if (parseFloat(numNetChangeInRs) < 0) {
        arrChnageData.push('-' + Math.abs(parseFloat(numNetChangeInRs)).toFixed(nFormat));
        arrChnageData.push("-" + Math.abs(parseFloat(PercNetChange)).toFixed(2) + "%");
        //arrChnageData.push("-" + Math.abs(parseFloat(PercNetChange)).toFixed(2));
        LTPTrend = "color-negative";
      } else {
        arrChnageData.push(Math.abs(parseFloat(numNetChangeInRs)).toFixed(nFormat));
        //arrChnageData.push("(" + Math.abs(parseFloat(PercNetChange)).toFixed(2) + "%)");
        arrChnageData.push("" + Math.abs(parseFloat(PercNetChange)).toFixed(2) + "");
        LTPTrend = "";
      }

      //arrChnageData.push(Math.abs(parseFloat(numNetChangeInRs)).toFixed(nFormat));
      //arrChnageData.push(Math.abs(parseFloat(PercNetChange)).toFixed(2));
      arrChnageData.push(LTPTrend);
      arrChnageData.push(parseFloat(PercNetChange));

      if (isMktWatch !== undefined && isMktWatch)
        arrChnageData.push(PercNetChange);

    } else {
      let zeroVal = 0;
      arrChnageData.push(zeroVal.toFixed(nFormat));
      arrChnageData.push('0.00');
      arrChnageData.push('');
      if (isMktWatch !== undefined && isMktWatch)
        arrChnageData.push('0.00');
    }

    return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: arrChnageData };

  } catch (error) {
    console.log('error', error);
    return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };

  }
}


function _kFormatterOI(value) {
  try {
    let num = parseFloat(value);
    var si = [
      { value: 1, symbol: "" },
      { value: 1E3, symbol: "K" },
      { value: 1E5, symbol: "L" },
      { value: 1E7, symbol: "Cr." },
      { value: 1E12, symbol: "Cr." },
      { value: 1E15, symbol: "Cr." },
      { value: 1E18, symbol: "Cr." }
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }

    let _returnvalue = (Math.floor((num / si[i].value) * 100) / 100).toString().replace(rx, "$1");

    return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: _returnvalue + ' ' + si[i].symbol };

  } catch (error) {
    console.log("e", error);
    return { status: false, messsage: BUSINESS_LAYER_RESPONSE.FAILURE, error };
  }
}




function _fn_NormalDensityFunction(nVal) {
  let result = 0.39894228040133 * Math.exp(-nVal * nVal / 2);
  return result;
}



function _fn_StdNormal(nX) {
  try {
    let lnResult;
    if (nX < -7.0)
      lnResult = _fn_NormalDensityFunction(nX) / (Math.sqrt(1.0 + nX * nX));
    else if (nX > 7.0)
      lnResult = 1.0 - _fn_StdNormal(-nX);
    else {
      lnResult = 0.2316419;
      let nNormalValues = [0.31938153, -0.356563782, 1.7814477937, -1.8212255978, 1.330274429];
      lnResult = 1.0 / (1 + lnResult * Math.abs(nX));
      lnResult = 1 - _fn_NormalDensityFunction(nX) * (lnResult * (nNormalValues[0] +
        lnResult * (nNormalValues[1] +
          lnResult * (nNormalValues[2] +
            lnResult * (nNormalValues[3] +
              lnResult * (nNormalValues[4]))))));
      if (nX <= 0.0)
        lnResult = 1.0 - lnResult;
    }
    return lnResult;

  } catch (error) {
    console.log('error', error);
  }
}



function _callOptionValue(nIndexPrice, nStrikePrice, nInterestRate, nHighSigma, nExpiryDays) {
  let lnCall = 0.0,
    lnIndexPrice = 0.0, lnStrikePrice = 0.0, lnVolatility = 0.0,
    lnInterestRate = 0.0, lnDaysUntilExpiry = 0.0;
  let lnD1 = 0.0, lnD2 = 0.0;
  let lnStdNormalD1 = 0.0, lnStdNormalD2 = 0.0;

  lnIndexPrice = nIndexPrice;
  lnStrikePrice = nStrikePrice;
  lnInterestRate = nInterestRate / 100.00;
  lnDaysUntilExpiry = nExpiryDays / 365.0;
  lnVolatility = nHighSigma / 100.00;

  /*
  The Following Steps are required to Calculate the Black & Scholes Model
  Steps :
  lnD1 = (LN(IndexPrice/StrikePrice) + (InterestRate + pow(volatilty, 2)/2)*daysUntilExpiry )/ Volatility*pow((DaysUntilExpiry), 1/2)
  lnD2 = lnD1 - Volatility*pow((DaysUntilExpiry), 1/2)
  Call = IndexPrice * N(lnD1) - StrikePrice * EXP(-InterestRate*DaysUntilExpiry) * N(lnD2)
  Put  = StrikePrice  * EXP(-InterestRate*DaysUntilExpiry)*N(-lnD2) - IndexPrice * N(-lnD1)  
  */

  let lnExponential = Math.exp((-lnInterestRate) * lnDaysUntilExpiry);
  let lnNaturalLog = 0.0;
  //if(lnStrikePrice != 0)
  if (lnStrikePrice !== 0 && lnIndexPrice !== 0) // Bhushit A on 28Feb2013 for Bonanza: 001-00-346812 Open -- Odin Client exe crash / 001-00-347079 Open -- Broadcast delay issue
  {
    if ((lnIndexPrice / lnStrikePrice) > 0)  //-- Amol K - 001-00-295201 - Client application is getting crashed while adding scrip in  Greek watch window -- [15/06/2012]
      lnNaturalLog = Math.log(lnIndexPrice / lnStrikePrice);
  }
  let lnVolatilitySq = Math.pow(lnVolatility, 2);
  let lnSqrtDaysUntilExpiry = Math.pow(lnDaysUntilExpiry, 0.5);


  if ((lnVolatility * lnSqrtDaysUntilExpiry) !== 0)
    lnD1 = (lnNaturalLog + ((lnInterestRate + (lnVolatilitySq / 2)) * lnDaysUntilExpiry)) / (lnVolatility * lnSqrtDaysUntilExpiry);
  lnD2 = lnD1 - lnVolatility * Math.pow((lnDaysUntilExpiry), 0.5);
  lnStdNormalD1 = _fn_StdNormal(lnD1);
  lnStdNormalD2 = _fn_StdNormal(lnD2);
  if ((lnVolatility * lnSqrtDaysUntilExpiry) === 0) {
    if (lnNaturalLog >= 0) {
      lnStdNormalD1 = 1;
      lnStdNormalD2 = 1;
    }
    else {
      lnStdNormalD1 = 0;
      lnStdNormalD2 = 0;
    }
  }

  lnCall = lnIndexPrice * lnStdNormalD1 - lnStrikePrice * lnExponential * lnStdNormalD2;

  return lnCall;

}

function _putOptionValue(nIndexPrice, nStrikePrice, nInterestRate, nHighSigma, nExpiryDays) {

  let lnPut = 0.0,
    lnIndexPrice = 0.0, lnStrikePrice = 0.0, lnVolatility = 0.0,
    lnInterestRate = 0.0, lnDaysUntilExpiry = 0.0;
  let lnD1 = 0.0, lnD2 = 0.0;
  let lnStdNormalD1 = 0.0, lnStdNormalD2 = 0.0;

  lnIndexPrice = nIndexPrice;
  lnStrikePrice = nStrikePrice;
  lnInterestRate = nInterestRate / 100.00;
  lnDaysUntilExpiry = nExpiryDays / 365.0;
  lnVolatility = nHighSigma / 100.00;

  /*
  The Following Steps are required to Calculate the Black & Scholes Model
  Steps :
  lnD1 = (LN(IndexPrice/StrikePrice) + (InterestRate + pow(volatilty, 2)/2)*daysUntilExpiry )/ Volatility*pow((DaysUntilExpiry), 1/2)
  lnD2 = lnD1 - Volatility*pow((DaysUntilExpiry), 1/2)
  Call = IndexPrice * N(lnD1) - StrikePrice * EXP(-InterestRate*DaysUntilExpiry) * N(lnD2)
  Put  = StrikePrice  * EXP(-InterestRate*DaysUntilExpiry)*N(-lnD2) - IndexPrice * N(-lnD1)  
  */

  let lnExponential = Math.exp((-lnInterestRate) * lnDaysUntilExpiry);
  let lnNaturalLog = 0.0;
  //if(lnStrikePrice != 0)
  if (lnStrikePrice !== 0 && lnIndexPrice !== 0) // Bhushit A on 28Feb2013 for Bonanza: 001-00-346812 Open -- Odin Client exe crash / 001-00-347079 Open -- Broadcast delay issue
    lnNaturalLog = Math.log(lnIndexPrice / lnStrikePrice);
  let lnVolatilitySq = Math.pow(lnVolatility, 2);
  let lnSqrtDaysUntilExpiry = Math.pow(lnDaysUntilExpiry, 0.5);


  if ((lnVolatility * lnSqrtDaysUntilExpiry) !== 0)
    lnD1 = (lnNaturalLog + ((lnInterestRate + (lnVolatilitySq / 2)) * lnDaysUntilExpiry)) / (lnVolatility * lnSqrtDaysUntilExpiry);
  lnD2 = lnD1 - lnVolatility * Math.pow((lnDaysUntilExpiry), 0.5);
  lnStdNormalD1 = _fn_StdNormal(-lnD1);
  lnStdNormalD2 = _fn_StdNormal(-lnD2);
  if ((lnVolatility * lnSqrtDaysUntilExpiry) === 0) {
    if (lnNaturalLog >= 0) {
      lnStdNormalD1 = 0;
      lnStdNormalD2 = 0;
    }
    else {
      lnStdNormalD1 = 1;
      lnStdNormalD2 = 1;
    }
  }
  lnPut = lnStrikePrice * lnExponential * lnStdNormalD2 - lnIndexPrice * lnStdNormalD1;

  return lnPut;

}


//Option chain BT-114363 Start
function _getOIInPercent(OIChange) {
  try {
    let arrChnageData = [];
    OIChange = OIChange === '' ? "0.00" : OIChange;
    if (parseFloat(OIChange) > 0) {
      arrChnageData.push('+' + Math.abs(parseFloat(OIChange)).toFixed(2) + "%");
      arrChnageData.push("(+" + Math.abs(parseFloat(OIChange)).toFixed(2) + "%)");
      arrChnageData.push('color-positive');
    }
    else if (parseFloat(OIChange) < 0) {
      arrChnageData.push('-' + Math.abs(parseFloat(OIChange)).toFixed(2) + "%");
      arrChnageData.push("(-" + Math.abs(parseFloat(OIChange)).toFixed(2) + "%)");
      arrChnageData.push('color-negative');
    } else {
      arrChnageData.push(Math.abs(parseFloat(OIChange)).toFixed(2));
      arrChnageData.push("(" + Math.abs(parseFloat(OIChange)).toFixed(2) + ")");
      arrChnageData.push('');
    }
    return arrChnageData;
  } catch (error) {

  }
}












function _impliedVolatility(nIndexPrice, nStrikePrice, nInterestRate, nExpiryDays, nPrice, nCallOrPut) {
  // Bhushit A for CR1082 001-00-365412/001-00-345355: Buy & Sell Volatility  problem in Odin Client. on 5Feb13
  if (nIndexPrice <= 0) {
    return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: 0.0 };
  }
  // Bhushit A for CR1082 001-00-345355: Buy & Sell Volatility  problem in Odin Client. on 5Feb13 End 

  let lnLowSigma = 0.0001;
  let lnPrice = 0.0;
  if (nCallOrPut === 'CALL') {
    lnPrice = _callOptionValue(nIndexPrice, nStrikePrice, nInterestRate, lnLowSigma, nExpiryDays);
  }
  if (nCallOrPut === 'PUT') {
    lnPrice = _putOptionValue(nIndexPrice, nStrikePrice, nInterestRate, lnLowSigma, nExpiryDays);
  }
  if (lnPrice > nPrice) {
    return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: 0.0 };
  }


  let lnAccuracy = 1.0e-10/*4*//*2*/; // make this smaller for higher accuracy
  let lnMaxIterations = 100;
  let lnHighValue = 1e10;
  let lnError = 0;

  // want to bracket sigma. first find a maximum sigma by finding a sigma
  // with a estimated lnPrice higher than the actual lnPrice.

  let lnSigmaHigh = 0.3;
  if (nCallOrPut === 'CALL') {
    lnPrice = _callOptionValue(nIndexPrice, nStrikePrice, nInterestRate, lnSigmaHigh, nExpiryDays);
  }
  if (nCallOrPut === 'PUT') {
    lnPrice = _putOptionValue(nIndexPrice, nStrikePrice, nInterestRate, lnSigmaHigh, nExpiryDays);
  }
  while (lnPrice < nPrice) {
    lnSigmaHigh = 2.0 * lnSigmaHigh; // keep doubling.
    if (nCallOrPut === 'CALL') {
      lnPrice = _callOptionValue(nIndexPrice, nStrikePrice, nInterestRate, lnSigmaHigh, nExpiryDays);
    }
    if (nCallOrPut === 'PUT') {
      lnPrice = _putOptionValue(nIndexPrice, nStrikePrice, nInterestRate, lnSigmaHigh, nExpiryDays);
    }
    if (lnSigmaHigh > lnHighValue) {
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: lnError };
    }
  }

  for (let i = 0; i < lnMaxIterations; i++) {
    let lnSigma = (lnLowSigma + lnSigmaHigh) * 0.5;
    if (nCallOrPut === 'CALL') {
      lnPrice = _callOptionValue(nIndexPrice, nStrikePrice, nInterestRate, lnSigma, nExpiryDays);
    }
    if (nCallOrPut === 'PUT') {
      lnPrice = _putOptionValue(nIndexPrice, nStrikePrice, nInterestRate, lnSigma, nExpiryDays);
    }
    //fabs
    let lnTest = (lnPrice - nPrice);
    if (Math.abs(lnTest) < lnAccuracy) {
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: lnSigma };
    }
    if (lnTest < 0.0) {
      lnLowSigma = lnSigma;
    }
    else {
      lnSigmaHigh = lnSigma;
    }
  }

  return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: lnError };

}


function _showcalculate(nIndexPrice, nStrikePrice, nInterestRate, nDaysUntilExpiration, pVolatility, nOption) {



  try {
    let nGammaCall, nGammaPut, nThetaCall, nThetaPut, nVegaCall, nVegaPut, nRhoCall, nRhoPut, nDeltaCall, nDeltaPut, nTheoCall, nTheoPut;
    let lnCall, lnPut, lnIndexPrice, lnStrikePrice, lnVolatility, lnInterestRate, lnDaysUntilExpiry;
    let nActualMarketPrice;
    let lnD1, lnD2;
    let lnstdNormal1, lnstdNormal2, lnstdNormal3, lnstdNormal4;
    lnIndexPrice = nIndexPrice;
    lnStrikePrice = nStrikePrice;
    lnInterestRate = nInterestRate / 100.00;
    lnDaysUntilExpiry = nDaysUntilExpiration / 365.0;
    lnVolatility = parseFloat((pVolatility)) / 100.00;
    let lnExponential = Math.exp((-lnInterestRate) * lnDaysUntilExpiry);
    let lnNaturalLog = Math.log(lnIndexPrice / lnStrikePrice);
    let lnVolatilitySq = Math.pow(lnVolatility, 2);
    let lnSqrtDaysUntilExpiry = Math.pow(lnDaysUntilExpiry, 0.5);
    if (parseInt(nDaysUntilExpiration) === 0) {
      nGammaCall = 0;
      nGammaPut = 0;
      nThetaCall = 0;
      nThetaPut = 0;
      nVegaCall = 0;
      nVegaPut = 0;
      nRhoCall = 0;
      nRhoPut = 0;
      if (nIndexPrice >= nStrikePrice) {
        nDeltaCall = 1;
        nDeltaPut = 0;
        nTheoCall = nIndexPrice - nStrikePrice;
        nTheoPut = 0;
      }
      else {
        nDeltaCall = 0;
        nDeltaPut = -1;
        nTheoCall = 0;
        nTheoPut = nStrikePrice - nIndexPrice;
      }
      //call or put
      if (nOption === 0) {
        nActualMarketPrice = nTheoCall;
      } else { }
      if (nOption === 1) {
        nActualMarketPrice = nTheoPut;
      } else { }
    }
    else {
      lnD1 = (lnNaturalLog + ((lnInterestRate + (lnVolatilitySq / 2)) * lnDaysUntilExpiry)) / (lnVolatility * lnSqrtDaysUntilExpiry);
      lnD2 = lnD1 - lnVolatility * Math.pow((lnDaysUntilExpiry), 0.5);

      lnstdNormal1 = _fn_StdNormal(lnD1);
      lnstdNormal2 = _fn_StdNormal(lnD2);
      lnstdNormal3 = _fn_StdNormal(-lnD2);
      lnstdNormal4 = _fn_StdNormal(-lnD1);
      lnCall = lnIndexPrice * lnstdNormal1 - lnStrikePrice * lnExponential * lnstdNormal2;
      lnPut = lnStrikePrice * lnExponential * lnstdNormal3 - lnIndexPrice * lnstdNormal4;
      let lpFormatedCall;
      let lpFormatedPut;
      //**
      lpFormatedCall = lnCall.toFixed(4);
      lpFormatedPut = lnPut.toFixed(4);
      // this.nCall = lpFormatedCall;
      // this.nPut = lpFormatedPut;
      let lnDeltaCall, lnDeltaPut;
      let lpFormatedDeltaCall;
      let lpFormatedDeltaPut;
      lnDeltaCall = lnstdNormal1;
      lnDeltaPut = lnstdNormal1 - 1;
      lpFormatedDeltaCall = lnDeltaCall.toFixed(4);
      lpFormatedDeltaPut = lnDeltaPut.toFixed(4);
      nDeltaCall = lpFormatedDeltaCall === "NaN" ? '-' : parseFloat(lpFormatedDeltaCall);
      nDeltaPut = lpFormatedDeltaPut === "NaN" ? '-' : parseFloat(lpFormatedDeltaPut);
      let Normalpdf = Math.exp(-Math.pow(lnD1, 2) / 2) / 2.507132680972429;//Math.sqrt(2 * 3.14285714); // impr
      let lnGammaCall, lnGammaPut;
      let lpFormatedGammaCall;
      let lpFormatedGammaPut;
      lnGammaCall = Normalpdf / (lnIndexPrice * lnVolatility * lnSqrtDaysUntilExpiry);
      lnGammaPut = Normalpdf / (lnIndexPrice * lnVolatility * lnSqrtDaysUntilExpiry);
      lpFormatedGammaCall = lnGammaCall.toFixed(4);
      lpFormatedGammaPut = lnGammaPut.toFixed(4);
      nGammaCall = lpFormatedGammaCall === "NaN" ? '-' : parseFloat(lpFormatedGammaCall);
      nGammaPut = lpFormatedGammaPut === "NaN" ? '-' : parseFloat(lpFormatedGammaPut);
      let lnThetaCall, lnThetaPut;
      let lpFormatedThetaCall;
      let lpFormatedThetaPut;
      lnThetaCall = -((lnIndexPrice * Normalpdf * lnVolatility) / 2.0 / lnSqrtDaysUntilExpiry) -
        (lnInterestRate * lnStrikePrice * lnExponential * lnstdNormal2);
      lnThetaPut = -(lnIndexPrice * Normalpdf * lnVolatility / 2.0 / lnSqrtDaysUntilExpiry)
        + (lnInterestRate * lnStrikePrice * lnExponential * (1 - lnstdNormal2));
      lnThetaCall = (lnThetaCall / 365.0);
      lpFormatedThetaCall = lnThetaCall.toFixed(4);
      lnThetaPut = (lnThetaPut / 365.0);
      lpFormatedThetaPut = lnThetaPut.toFixed(4);
      nThetaCall = lpFormatedThetaCall === "NaN" ? '-' : parseFloat(lpFormatedThetaCall);
      nThetaPut = lpFormatedThetaPut === "NaN" ? '-' : parseFloat(lpFormatedThetaPut);
      let lnVegaCall, lnVegaPut;
      let lpFormatedVegaCall;
      let lpFormatedVegaPut;
      lnVegaCall = lnIndexPrice * Normalpdf * lnSqrtDaysUntilExpiry;
      lnVegaPut = lnIndexPrice * Normalpdf * lnSqrtDaysUntilExpiry;
      lnVegaCall = lnVegaCall / 100.0;
      lpFormatedVegaCall = lnVegaCall.toFixed(4);
      lnVegaPut = lnVegaPut / 100.0;
      lpFormatedVegaPut = lnVegaPut.toFixed(4);
      nVegaCall = lpFormatedVegaCall === "NaN" ? '-' : parseFloat(lpFormatedVegaCall);
      nVegaPut = lpFormatedVegaPut === "NaN" ? '-' : parseFloat(lpFormatedVegaPut);
      let lnRhoCall, lnRhoPut;
      let lpFormatedRhoCall;
      let lpFormatedRhoPut;
      lnRhoCall = lnStrikePrice * lnExponential * lnDaysUntilExpiry * lnstdNormal2;
      lnRhoPut = -lnDaysUntilExpiry * lnExponential * (lnIndexPrice) * lnstdNormal3;
      lnRhoCall = lnRhoCall / 100.0;
      lpFormatedRhoCall = lnRhoCall.toFixed(4);
      lnRhoPut = lnRhoPut / 100.0;
      lpFormatedRhoPut = lnRhoPut.toFixed(4);
      nRhoCall = lpFormatedRhoCall === "NaN" ? '-' : parseFloat(lpFormatedRhoCall);
      nRhoPut = lpFormatedRhoPut === "NaN" ? '-' : parseFloat(lpFormatedRhoPut);
      // this.nTheoCall = this.nCall;
      // this.nTheoPut = this.nPut;

      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { nGammaCall, nGammaPut, nThetaCall: nThetaCall, nThetaPut, nVegaCall, nVegaPut, nDeltaCall, nDeltaPut } };
    }
  } catch (error) {
    console.log('error', error);
    return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
  }
}


function _optionChainShowCalculate(nIndexPrice, nStrikePrice, nInterestRate, nDaysUntilExpiration, pVolatility, nOption, nDividentYield = 0, nCall = 0, nPut = 0) {



  try {
    let nGammaCall, nGammaPut, nThetaCall, nThetaPut, nVegaCall, nVegaPut, nRhoCall, nRhoPut, nDeltaCall, nDeltaPut, nTheoCall, nTheoPut;
    let lnCall, lnPut, lnIndexPrice, lnStrikePrice, lnVolatility, lnInterestRate, lnDaysUntilExpiry, lnDividentYield;
    let nActualMarketPrice;
    let lnD1, lnD2;
    let lnstdNormal1, lnstdNormal2, lnstdNormal3, lnstdNormal4;
    lnIndexPrice = nIndexPrice;
    lnStrikePrice = nStrikePrice;
    lnInterestRate = nInterestRate / 100.00;
    lnDaysUntilExpiry = nDaysUntilExpiration / 365.0;
    lnVolatility = parseFloat((pVolatility)) / 100.00;
    let lnExponential = Math.exp((-lnInterestRate) * lnDaysUntilExpiry);
    let lnNaturalLog = Math.log(lnIndexPrice / lnStrikePrice);
    let lnVolatilitySq = Math.pow(lnVolatility, 2);
    let lnSqrtDaysUntilExpiry = Math.pow(lnDaysUntilExpiry, 0.5);
    if (parseInt(nDaysUntilExpiration) === 0) {
      nGammaCall = 0;
      nGammaPut = 0;
      nThetaCall = 0;
      nThetaPut = 0;
      nVegaCall = 0;
      nVegaPut = 0;
      nRhoCall = 0;
      nRhoPut = 0;
      if (nIndexPrice >= nStrikePrice) {
        nDeltaCall = 1;
        nDeltaPut = 0;
        nTheoCall = nIndexPrice - nStrikePrice;
        nTheoPut = 0;
      }
      else {
        nDeltaCall = 0;
        nDeltaPut = -1;
        nTheoCall = 0;
        nTheoPut = nStrikePrice - nIndexPrice;
      }
      //call or put
      if (nOption === 0) {
        nActualMarketPrice = nTheoCall;
      }
      if (nOption === 1) {
        nActualMarketPrice = nTheoPut;
      }
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { nGammaCall, nGammaPut, nThetaCall, nThetaPut, nVegaCall, nVegaPut, nDeltaCall, nDeltaPut, nTheoCall, nTheoPut, nActualMarketPrice, nRhoCall, nRhoPut } };
    }
    else {
      if (nDividentYield === 0) {
        lnD1 = (lnNaturalLog + ((lnInterestRate + (lnVolatilitySq / 2)) * lnDaysUntilExpiry)) / (lnVolatility * lnSqrtDaysUntilExpiry);
        lnD2 = lnD1 - lnVolatility * Math.pow((lnDaysUntilExpiry), 0.5);
        lnstdNormal1 = _fn_StdNormal(lnD1);
        lnstdNormal2 = _fn_StdNormal(lnD2);
        lnstdNormal3 = _fn_StdNormal(-lnD2);
        lnstdNormal4 = _fn_StdNormal(-lnD1);
        lnCall = lnIndexPrice * lnstdNormal1 - lnStrikePrice * lnExponential * lnstdNormal2;
        lnPut = lnStrikePrice * lnExponential * lnstdNormal3 - lnIndexPrice * lnstdNormal4;
        let lpFormatedCall;
        let lpFormatedPut;
        //**
        lpFormatedCall = lnCall.toFixed(4);
        lpFormatedPut = lnPut.toFixed(4);
        nCall = lpFormatedCall;
        nPut = lpFormatedPut;
        let lnDeltaCall, lnDeltaPut;
        let lpFormatedDeltaCall;
        let lpFormatedDeltaPut;
        lnDeltaCall = lnstdNormal1;
        lnDeltaPut = lnstdNormal1 - 1;
        lpFormatedDeltaCall = lnDeltaCall.toFixed(4);
        lpFormatedDeltaPut = lnDeltaPut.toFixed(4);
        nDeltaCall = lpFormatedDeltaCall === "NaN" ? '-' : parseFloat(lpFormatedDeltaCall);
        nDeltaPut = lpFormatedDeltaPut === "NaN" ? '-' : parseFloat(lpFormatedDeltaPut);
        let Normalpdf = Math.exp(-Math.pow(lnD1, 2) / 2) / 2.507132680972429;//Math.sqrt(2 * 3.14285714); // impr
        let lnGammaCall, lnGammaPut;
        let lpFormatedGammaCall;
        let lpFormatedGammaPut;
        lnGammaCall = Normalpdf / (lnIndexPrice * lnVolatility * lnSqrtDaysUntilExpiry);
        lnGammaPut = Normalpdf / (lnIndexPrice * lnVolatility * lnSqrtDaysUntilExpiry);
        lpFormatedGammaCall = lnGammaCall.toFixed(4);
        lpFormatedGammaPut = lnGammaPut.toFixed(4);
        nGammaCall = lpFormatedGammaCall === "NaN" ? '-' : parseFloat(lpFormatedGammaCall);
        nGammaPut = lpFormatedGammaPut === "NaN" ? '-' : parseFloat(lpFormatedGammaPut);
        let lnThetaCall, lnThetaPut;
        let lpFormatedThetaCall;
        let lpFormatedThetaPut;
        lnThetaCall = -((lnIndexPrice * Normalpdf * lnVolatility) / 2.0 / lnSqrtDaysUntilExpiry) -
          (lnInterestRate * lnStrikePrice * lnExponential * lnstdNormal2);
        lnThetaPut = -(lnIndexPrice * Normalpdf * lnVolatility / 2.0 / lnSqrtDaysUntilExpiry)
          + (lnInterestRate * lnStrikePrice * lnExponential * (1 - lnstdNormal2));
        lnThetaCall = (lnThetaCall / 365.0);
        lpFormatedThetaCall = lnThetaCall.toFixed(4);
        lnThetaPut = (lnThetaPut / 365.0);
        lpFormatedThetaPut = lnThetaPut.toFixed(4);
        nThetaCall = lpFormatedThetaCall === "NaN" ? '-' : parseFloat(lpFormatedThetaCall);
        nThetaPut = lpFormatedThetaPut === "NaN" ? '-' : parseFloat(lpFormatedThetaPut);
        let lnVegaCall, lnVegaPut;
        let lpFormatedVegaCall;
        let lpFormatedVegaPut;
        lnVegaCall = lnIndexPrice * Normalpdf * lnSqrtDaysUntilExpiry;
        lnVegaPut = lnIndexPrice * Normalpdf * lnSqrtDaysUntilExpiry;
        lnVegaCall = lnVegaCall / 100.0;
        lpFormatedVegaCall = lnVegaCall.toFixed(4);
        lnVegaPut = lnVegaPut / 100.0;
        lpFormatedVegaPut = lnVegaPut.toFixed(4);
        nVegaCall = lpFormatedVegaCall === "NaN" ? '-' : parseFloat(lpFormatedVegaCall);
        nVegaPut = lpFormatedVegaPut === "NaN" ? '-' : parseFloat(lpFormatedVegaPut);
        let lnRhoCall, lnRhoPut;
        let lpFormatedRhoCall;
        let lpFormatedRhoPut;
        lnRhoCall = lnStrikePrice * lnExponential * lnDaysUntilExpiry * lnstdNormal2;
        lnRhoPut = -lnDaysUntilExpiry * lnExponential * (lnIndexPrice) * lnstdNormal3;
        lnRhoCall = lnRhoCall / 100.0;
        lpFormatedRhoCall = lnRhoCall.toFixed(4);
        lnRhoPut = lnRhoPut / 100.0;
        lpFormatedRhoPut = lnRhoPut.toFixed(4);
        nRhoCall = lpFormatedRhoCall === "NaN" ? '-' : parseFloat(lpFormatedRhoCall);
        nRhoPut = lpFormatedRhoPut === "NaN" ? '-' : parseFloat(lpFormatedRhoPut);
        nTheoCall = nCall;
        nTheoPut = nPut;
        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { nGammaCall, nGammaPut, nThetaCall, nThetaPut, nVegaCall, nVegaPut, nDeltaCall, nDeltaPut, nTheoCall, nTheoPut, nActualMarketPrice, nRhoCall, nRhoPut } };
      } else {
        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: null };
      }
    }
  } catch (error) {
    console.log('error', error);
    return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
  }
}

const lakhFormatter = (value) => {
  try {
    let num = parseFloat(value);
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

    let _returnvalue = (Math.round((num / 100000) * 1000) / 1000).toString().replace(rx, "$1");
    return _returnvalue;

  } catch (e) {
    return "0.00";
  }
};

export function _calculateGridDataForCall(
  nLTP,
  nClosePrice,
  nOpenInt,
  nDateDifference,
  nStrikePrice,
  sOptionType,
  nMktID,
  nToken,
  nSpotLTP,
  nScripLTP,
  percChangeLTP,
  changeInLTP,
  askQty,
  buyPrice,
  sellPrice,
  obj,
  nPercOpenInt,
  volume = 0,
  arrRowData
) {
  try {
    const nOption = 'CALL';
    let percNetChange = _getChangeInRs(nLTP, nClosePrice, 2, false, 'arrow')?.data[0];
    let OI_CALC;


    let PERCENT_OI;


    if (nOpenInt !== '') {
      OI_CALC = lakhFormatter(nOpenInt);
    }
    PERCENT_OI = _getOIInPercent(nPercOpenInt);
    let OI = OI_CALC + " " + PERCENT_OI[1];

    let calculateIV = _impliedVolatility(parseFloat(nSpotLTP), parseFloat(nStrikePrice), 4, nDateDifference, parseFloat(nScripLTP), nOption)?.data;
    let IV = parseFloat(calculateIV).toFixed(4);
    const { nGammaCall, nThetaCall, nVegaCall, nDeltaCall } = _showcalculate(nSpotLTP, nStrikePrice, 4, nDateDifference, IV, 0)?.data;
    let objVolume = obj[OPTION_CHAIN_GRID_INDEX?.VOLUME_CALL] === '0.00' ? 0 : obj[OPTION_CHAIN_GRID_INDEX?.VOLUME_CALL];
    arrRowData[OPTION_CHAIN_GRID_INDEX.GAMMA_CALL] = nGammaCall;
    arrRowData[OPTION_CHAIN_GRID_INDEX.THETA_CALL] = nThetaCall?.toFixed(2);
    arrRowData[OPTION_CHAIN_GRID_INDEX.VEGA_CALL] = nVegaCall;
    arrRowData[OPTION_CHAIN_GRID_INDEX.DELTA_CALL] = nDeltaCall;
    arrRowData[OPTION_CHAIN_GRID_INDEX.VOLUME_CALL] = volume > 0 ? volume : objVolume > 0 ? objVolume : volume <= 0 ? 0 : volume;
    arrRowData[OPTION_CHAIN_GRID_INDEX.IV_CALL] = IV;
    arrRowData[OPTION_CHAIN_GRID_INDEX.OI_CALL] = OI;
    arrRowData[OPTION_CHAIN_GRID_INDEX.PERCENT_CHANGE_CALL] = percNetChange;
    arrRowData[OPTION_CHAIN_GRID_INDEX.LTP_CALL] = nLTP;
    arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_PERCENT_CHANGE_LTP] = percChangeLTP;
    arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_CHANGE_IN_LTP] = changeInLTP;
    arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_ASK_QTY] = askQty;
    arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_BUY_PRICE] = buyPrice;
    arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SELL_PRICE] = sellPrice;
    return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: arrRowData };
  } catch (error) {

  }
}

export function _calculateGridDataForPut(
  nLTP,
  nClosePrice,
  nOpenInt,
  nDateDifference,
  nStrikePrice,
  sOptionType,
  nMktID,
  nToken,
  nSpotLTP,
  nScripLTP,
  percChangeLTP,
  changeInLTP,
  askQty,
  buyPrice,
  sellPrice,
  obj,
  nPercOpenInt,
  volume = 0,
  arrRowData
) {
  try {
    const nOption = 'PUT';
    let percNetChange = _getChangeInRs(nLTP, nClosePrice, 2, false, 'arrow')?.data[0];
    let OI_CALC;
    let PERCENT_OI;
    if (nOpenInt !== '') {
      OI_CALC = lakhFormatter(nOpenInt);
    }
    PERCENT_OI = _getOIInPercent(nPercOpenInt);

    let OI = OI_CALC + " " + PERCENT_OI[1];

    let calculateIV = _impliedVolatility(parseFloat(nSpotLTP), parseFloat(nStrikePrice), 4, nDateDifference, parseFloat(nScripLTP), nOption)?.data;
    let IV = parseFloat(calculateIV).toFixed(4);

    const { nGammaPut, nThetaPut, nVegaPut, nDeltaPut } = _showcalculate(nSpotLTP, nStrikePrice, 4, nDateDifference, IV, 1)?.data;
    let objVolume1 = obj[OPTION_CHAIN_GRID_INDEX?.VOLUME_PUT] === '0.00' ? 0 : obj[OPTION_CHAIN_GRID_INDEX?.VOLUME_PUT];
    arrRowData[OPTION_CHAIN_GRID_INDEX.GAMMA_PUT] = nGammaPut;
    arrRowData[OPTION_CHAIN_GRID_INDEX.THETA_PUT] = nThetaPut?.toFixed(2);
    arrRowData[OPTION_CHAIN_GRID_INDEX.VEGA_PUT] = nVegaPut;
    arrRowData[OPTION_CHAIN_GRID_INDEX.DELTA_PUT] = nDeltaPut;
    arrRowData[OPTION_CHAIN_GRID_INDEX.VOLUME_PUT] = volume > 0 ? volume : objVolume1 > 0 ? objVolume1 : volume <= 0 ? 0 : volume;
    arrRowData[OPTION_CHAIN_GRID_INDEX.IV_PUT] = IV;
    arrRowData[OPTION_CHAIN_GRID_INDEX.OI_PUT] = OI;
    arrRowData[OPTION_CHAIN_GRID_INDEX.PERCENT_CHANGE_PUT] = percNetChange;
    arrRowData[OPTION_CHAIN_GRID_INDEX.LTP_PUT] = nLTP;
    arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_PERCENT_CHANGE_LTP] = percChangeLTP;
    arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_CHANGE_IN_LTP] = changeInLTP;
    arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_ASK_QTY] = askQty;
    arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_BUY_PRICE] = buyPrice;
    arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SELL_PRICE] = sellPrice;
    return {
      status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: arrRowData
    };
  } catch (error) {

  }
}

function _calculateGridData(nLTP, nClosePrice, nOpenInt, nDateDifference, nStrikePrice, sOptionType, nMktID, nToken, nSpotLTP, nScripLTP, percChangeLTP, changeInLTP, askQty, buyPrice, sellPrice, obj, nPercOpenInt, volume = 0) {

  //nScripLtpShould be spot price 
  try {

    const nOption = sOptionType === "CE" ? 'CALL' : 'PUT';

    let percNetChange = _getChangeInRs(nLTP, nClosePrice, 2, false, 'arrow')?.data[0];
    let OI_CALC;


    let PERCENT_OI;


    if (nOpenInt !== '') {
      OI_CALC = lakhFormatter(nOpenInt);
      //  _kFormatterOI(nOpenInt)?.data;
    }



    PERCENT_OI = _getOIInPercent(nPercOpenInt);




    let OI = OI_CALC + " " + PERCENT_OI[1];



    let calculateIV = _impliedVolatility(parseFloat(nSpotLTP), parseFloat(nStrikePrice), 4, nDateDifference, parseFloat(nScripLTP), nOption)?.data;
    let IV = parseFloat(calculateIV).toFixed(4);
    if (sOptionType === "CE") {


      const { nGammaCall, nThetaCall, nVegaCall, nDeltaCall } = _showcalculate(nSpotLTP, nStrikePrice, 4, nDateDifference, IV, 0)?.data;
      let objVolume = obj?.VOLUME_CALL;
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { ...obj, VOLUME_CALL: volume > 0 ? volume : objVolume > 0 ? objVolume : volume <= 0 ? 0 : volume, OI_CALL: OI, IV_CALL: IV, GAMMA_CALL: nGammaCall, THETA_CALL: nThetaCall?.toFixed(2), VEGA_CALL: nVegaCall, DELTA_CALL: nDeltaCall, PERCENT_CHANGE_CALL: percNetChange, MKT_ID_CALL: nMktID, TOKEN_CALL: nToken, LTP_CALL: nLTP, LTP_PERCENT_CALL: percChangeLTP, CHANGE_IN_LTP_CALL: changeInLTP, ASK_QTY_CALL: askQty, BUY_PRICE_CALL: buyPrice, SELL_PRICE_CALL: sellPrice, OPT_TYPE_CALL: 'CE' } };

    } else if (sOptionType === "PE") {



      const { nGammaPut, nThetaPut, nVegaPut, nDeltaPut } = _showcalculate(nSpotLTP, nStrikePrice, 4, nDateDifference, IV, 1)?.data;
      let objVolume1 = obj?.VOLUME_PUT;
      return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { ...obj, VOLUME_PUT: volume > 0 ? volume : objVolume1 > 0 ? objVolume1 : volume <= 0 ? 0 : volume, OI_PUT: OI, IV_PUT: IV, GAMMA_PUT: nGammaPut, THETA_PUT: nThetaPut?.toFixed(2), VEGA_PUT: nVegaPut, DELTA_PUT: nDeltaPut, PERCENT_CHANGE_PUT: percNetChange, MKT_ID_PUT: nMktID, TOKEN_PUT: nToken, LTP_PUT: nLTP, LTP_PERCENT_PUT: percChangeLTP, CHANGE_IN_LTP_PUT: changeInLTP, ASK_QTY_PUT: askQty, BUY_PRICE_PUT: buyPrice, SELL_PRICE_PUT: sellPrice, OPT_TYPE_PUT: 'PE' } };


    }

  } catch (error) {

    return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };

  }

}


function _scrollToCurrentStrikePrice(nLTP, arrStrikPrices) {

  let index;

  for (let i = 0; i < arrStrikPrices.length; i++) {
    if (parseInt(nLTP) <= parseInt(arrStrikPrices[i])) {
      if (i >= arrStrikPrices.length) {
        index = arrStrikPrices?.length - 1;
      } else if (i = 0) {
        index = 0;
      } else {
        index = i;
      }
      break;
    }
  }

  return index;

}



function _subscriptionForVisibleRows(arrToSubscribe, arrOutViewRows) {

  try {

    const tokenSet = new Set(arrToSubscribe.map(item => item.token));
    const newArr = arrOutViewRows.filter(item => !tokenSet.has(item.token)).map(item => ({ token: item?.token, exchangeId: item?.exchangeId, isSubscribe: false }));

    return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: [...arrToSubscribe, ...newArr] };

  } catch (error) {

    return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };

  }

}



function _createStrategy(arrLegInfo, objOptionChainPayload, objExtraInfo, arrLegData = [], arrFutureData) {
  try {
    const legData = arrLegData ?? [];

    let legInfo = {
      legNumber: null,
      legPrice: null,
      sellPrice: null,
      buyPrice: null,
      expiryDate: null,
      symbol: null,
      ltpPercent: null,
      changeInLtp: null,
      strikeprice: null,
      optiontype: null,
      exchange: null,
      ask_qty: null,
      activeButtonToggleIndex: null,
      count: null,
      token: null,
      priceTick: null,
      instrument: null,
      extraInfo: null,
      expiryList: []
    };

    for (let i = 0; i < arrLegInfo.length; i++) {
      let additonalInfo = objExtraInfo[arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.SEGMENT_ID] + '_' + arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.TOKEN]];
      let length1 = arrLegData?.length === 0 ? legData?.length + 1 : arrLegData?.length + 1;
      let legInfo1 = {
        ...legInfo,
        legNumber: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.LEG_NUMBER],
        ltp: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.LTP],
        legPrice: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.LEG_PRICE],
        expiryDate: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.NEXPIRY_DATE],
        symbol: objOptionChainPayload?.symbol,
        ltpPercent: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.LTP_PERCENT],
        changeInLtp: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.CHANGE_IN_LTP],
        strikeprice: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.STRIKE_PRICE],
        optiontype: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.SCRIP_TYPE] === 'CE' ? 'CE' : arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.SCRIP_TYPE] === 'PE' ? 'PE' : "NA",
        exchange: additonalInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
        ask_qty: additonalInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT],
        token: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.TOKEN],
        priceTick: additonalInfo[WATCHLIST_GRID_INDEX.PRICE_TICK],
        instrument: additonalInfo[WATCHLIST_GRID_INDEX.INSTRUMENT],
        buyPrice: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.BUY_PRICE],
        sellPrice: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.SELL_PRICE],
        extraInfo: additonalInfo,
        activeButtonToggleIndex: (length1 % 2) !== 0 ? 0 : 1,
        count: '1',
        orderType: 'RL-MKT',
        selectedExpiry: arrLegInfo[i][MULTILEG_DATA_OPTION_INDEX.SELECTED_EXPIRY],
        decLoc: additonalInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
        decimalLocatorLength: additonalInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
        expiryList: arrFutureData
      };
      legData.push(legInfo1);
    }




    return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: legData?.sort((a, b) => a?.legNumber - b?.legNumber) };

  } catch (error) {
    return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
  }
}

function _optionContract(optionType) {
  let arrDropdown;
  try {
    if (optionType === OPTION_CHAIN.CALL || optionType === OPTION_CHAIN.PUT) {
      arrDropdown = Object.values({
        ATM: 'ATM',
        OTM: 'OTM',
        ITM: 'ITM'
      });
    } else if (optionType === OPTION_CHAIN.CALL_PUT) {
      arrDropdown = ['ALL'];
    }
    return { status: true, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: arrDropdown };
  } catch (error) {
    return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
  }
}



async function _fetchOptionDataBasedOnScreens(objPayload, objLoginSession) {

  try {
    let symbol = modifySymbol(objPayload?.symbol);
    let arrDistinctDates;
    let params = objPayload?.location === location?.INDICES ? getViewAllowed(objLoginSession) : getViewAllowedOptnChain(objPayload?.mappedId, objLoginSession);
    if (objPayload?.location !== location?.GLOBAL_SEARCH) {
      let instrumentName = objPayload?.location === location?.INDICES ? 'OPTIDX' : getInstrumentName(objPayload?.instrumentName);
      let getDistinctDates = await apiCall.get(`/nontransactional/${TenantId}/v1/getDistinctExpirybyToken/${objPayload?.assetToken}/${instrumentName}/${params}`);
      arrDistinctDates = await getDistinctDates?.data?.result?.aggregations?.optsym?.buckets[0]?.optexp?.buckets.map(item => item.key.toUpperCase());
    } else {
      arrDistinctDates = [...objPayload?.distinctDates];
    }
    //Ameersha N -BREEZE - BT-109096 - 12-04-2024 -- Scrip Overview Option Chain 
    const sortedDateStrings = arrDistinctDates?.sort((a, b) => sortDateInStringsInSequence(a) - sortDateInStringsInSequence(b));
    let expiryDate = objPayload?.location === location?.GLOBAL_SEARCH ? objPayload?.expiryDate : objPayload?.expiryDate?.length > 0 ? objPayload?.expiryDate : sortedDateStrings[0];
    let objOptionChainData = await apiCall.get(`/nontransactional/${TenantId}/v1/getScripFromInstrumentAndExchange/null/${expiryDate}/${symbol}/${objLoginSession?.nExchangesViewAllowed}`);
    let arrSelectedOptionContractData = objOptionChainData?.data?.result?.hits?.hits;
    return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrSelectedOptionContractData, arrDistinctDates } };
  } catch (error) {
    return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
  }
}


function _filterObjWRTOptionType(inputObject, type) {
  const result = {};

  for (const key in inputObject) {
    if (key.endsWith(`_${type}`)) {
      // Remove the last `_${type}` from the key
      const modifiedKey = key.slice(0, -(`_${type}`.length));
      result[modifiedKey] = inputObject[key];
    }
  }
  return result;
}



export { _filterObjWRTOptionType, _fetchOptionDataBasedOnScreens, _optionContract, _createStrategy, _modifyOptionDataWrtAPI, _scrollToCurrentStrikePrice, _calculateGridData, _modifyOptionData, _dateDiffernece, _getChangeInRs, _kFormatterOI, _impliedVolatility, _optionChainShowCalculate, _subscriptionForVisibleRows };